import { createSelector } from 'reselect';
import { initialState } from './reducer';
/**
 * Direct selector to the user state domain
 */
var selectVersionNewDomain = function (state) { return state.versionNew || initialState; };
var makeSelectVersionNew = function () {
    return createSelector(selectVersionNewDomain, function (substate) { return substate; });
};
export default makeSelectVersionNew;
export { selectVersionNewDomain };
